module.exports = "<abbr title=Collaborator (click)=addCol()><mat-icon>person_add</mat-icon></abbr>"